// Create and Edit payloads are intentionally identical. The edit endpoint uses
// PUT with the id in the URL (not in the body), so no id field is needed here.
// Kept as separate functions for consistency with the QuickLinks adapter pattern.
function buildKeyShoutPayload(
	data: Partial<KeyShout> & { audienceGroupIds?: number[] },
	imageReference: string | null,
	imageRemoved: boolean
): Record<string, unknown> {
	return {
		heading: data.heading ?? "",
		content: data.content ?? "",
		button_link: data.buttonLink ?? "",
		webview: data.webview ?? false,
		feed_id: data.feedId ?? null,
		image_reference: imageReference ?? null,
		image_removed: imageRemoved,
		audience_group_ids: data.audienceGroupIds ?? []
	};
}

export const adaptCreateKeyShoutPayload = (
	data: Partial<KeyShout> & { audienceGroupIds?: number[] },
	imageReference: string | null
): Record<string, unknown> => {
	return buildKeyShoutPayload(data, imageReference, false);
};

export const adaptEditKeyShoutPayload = (
	data: Partial<KeyShout> & { audienceGroupIds?: number[] },
	imageReference: string | null,
	imageRemoved = false
): Record<string, unknown> => {
	return buildKeyShoutPayload(data, imageReference, imageRemoved);
};
